/* eslint-disable */
import React, { useState } from 'react';
import { Field } from 'formik';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import polygon from '../../images/icons/polygon.svg';

const Level2Approver = ({
  values = {},
  setFieldValue,
  disabled = false,
  enableLevel2Approver = false,
  approverOptions = [{ label: 'Select', value: '' }],
  name = 'level2Assignee',
  label = 'Approver Name'
}) => {
  const [open, setOpen] = useState(true);
  const isDisabled = disabled || !enableLevel2Approver;

  return (
    <div className="my-4">
      <div
        onClick={() => setOpen((s) => !s)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setOpen((s) => !s)}
        aria-expanded={open}
        className={`flex flex-row place-content-between mb-4  mt-4 bg-secondary-500 p-1 px-2.5 rounded-md  cursor-pointer ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'bg-primary-300'}`} >
        <div className="text-base font-muli text-white-light font-bold">Level 2 Approver</div>
        <img src={polygon} alt="toggle" className={`${!open ? 'transform -rotate-90' : ''} w-6`} />
      </div>

      {open && (
        <div className="p-4 rounded border bg-white" style={{ border: '2px solid #EEEEEE', borderRadius: '10px' }}>
          <div className="grid grid-cols-3 gap-6 p-1 mb-4">
            <Field
              name={name}
              component={DropdownFieldComponent}
              options={approverOptions}
              className="w-full"
              rounded
              isDisabled={isDisabled}
              id="level2Approver"
              type="text"
              placeholder=""
              label={label}
              isClearable
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Level2Approver;
